import { StudentTerminationStatusGraduation } from './student-termination-status-graduation.model';
import { StudentTerminationStatusType } from './student-termination-status-type.model';
import { Student } from 'src/app/model/student/student.model';
export class StudentTerminationStatus {
    ID: number;
    STUDENTS_ID: number;
    STUDENT_TERMINATION_STATUS_TYPES_ID: number;
    STATUS_DATE: Date;
    CREATED_DATE: Date;
    CREATED_BY: string;
    MODIFIED_DATE: Date;
    MODIFIED_BY: string;
    STUDENT: Student;
    STUDENT_TERMINATION_STATUS_TYPES: StudentTerminationStatusType;
    STUDENT_TERMINATION_STATUS_GRADUATIONS: StudentTerminationStatusGraduation[];
}
